module.exports = __webpack_public_path__ + "static/img/banner.0a9b8ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.jpg
// module id = 92
// module chunks = 1